import * as types from '../../mutation_type'
import {
  getCookie,
  setCookie
} from '../../../../../../util/util'

export default {
  /**
   *  判断是否存在cookie(logoimgurl,allreqdomain)
   * @param state
   * @param res
   */
  [types.CMPYINFOBYREQDOMAIN] (state, res) {
    if (res.data.status == '001') {
      setCookie('getCmpyinfoByReqdomain', JSON.stringify(res.data))
      setCookie('allreqdomain', JSON.stringify(res.data.allreqdomain))
      if (getCookie('logoimgurl')) {
        state.logoimgurl = JSON.parse(getCookie('logoimgurl'))
      } else {
        setCookie('logoimgurl', JSON.stringify(res.data.logoimgurl))
      }
      if (getCookie('allreqdomain')) {
        state.allreqdomain = JSON.parse(getCookie('allreqdomain'))
      } else {
        setCookie('allreqdomain', JSON.stringify(res.data.allreqdomain))
      }
      if (getCookie('cmpycode')) {
        state.cmpycode = getCookie('cmpycode')
      } else {
        setCookie('cmpycode', res.data.cmpycode);
      }
    }
  },
  [types.GETADDRESS] (state, res) {
    state.selProvinces = res.data.data
  },
  [types.GETADDRESSCITY] (state, res) {
    state.selCity = res.data.data
  },
  [types.GETADDRESSAREA] (state, res) {
    state.selArea = res.data.data
  },
  [types.GETPUBCONFIGINFO] (state, res) {
    setCookie('getPubconfiginfo', JSON.stringify(res.data.data))
    state.getPubconfiginfo = res.data.data
  }
}



// WEBPACK FOOTER //
// ./src/pages/pc_mall_intact/store/modules/common/mutations/mutation.js